export default {
  namespaced: true,
  state: {
    feedbacks: [],
    feedbacks_view: [],
  },
  mutations: {
    SET_FEEDBACK(s, p) {
      s.feedbacks = [...p];
    },
    SET_FEEDBACK_VIEW(s, p) {
      s.feedbacks_view = [...p];
    },
  },
  getters: {
    getFeedbacks: (state) => state.feedbacks,
    getFeedbackView: (state) => state.feedbacks_view,
  },
  actions: {
    setFeedbacks({ commit }, p) {
      commit("SET_FEEDBACK", p);
    },
    setFeedBackView({ commit }, p) {
      commit("SET_FEEDBACK_VIEW", p);
    },
  },
};
